/**
 * @generated SignedSource<<a5a55db36ee509dea2fa3134ac2c0de3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePersonContactDialog_contact$data = {
  readonly emailAddress: string | null | undefined;
  readonly familyName: string;
  readonly givenName: string;
  readonly id: string;
  readonly phoneNumber: string | null | undefined;
  readonly salutation: string;
  readonly " $fragmentType": "UpdatePersonContactDialog_contact";
};
export type UpdatePersonContactDialog_contact$key = {
  readonly " $data"?: UpdatePersonContactDialog_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdatePersonContactDialog_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdatePersonContactDialog_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salutation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    }
  ],
  "type": "PersonContact",
  "abstractKey": null
};

(node as any).hash = "96740013ea2b52628e6a7669f20339aa";

export default node;
